import ExamSummary from './ExamSummary';

export default ExamSummary;
